import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateLottery = (params) => {
    return axios.post(`${backendHost}/api/admin/lottery/update`, params);
};

export {
    postUpdateLottery
}